export default __webpack_public_path__ + "static/media/Standard03.9bc529d0.png";